(function () {
  function init(scope) {
    var p = window.currentPageProduct;
    if (!p || !p.variants) return;
    var root = scope || document;
    var skuEl = root.querySelector('.product-meta-sku [data-product-sku]');
    var sel = root.querySelector('[data-product-form] [data-variants]');
    if (!skuEl || !sel) return;

    var byId = {};
    p.variants.forEach(function (v) { byId[v.id] = v.sku; });

    function syncSku() {
      var v = byId[parseInt(sel.value, 10)];
      if (v == null) return;
      skuEl.textContent = v;
      var row = skuEl.closest('.product-sku');
      if (row) row.style.display = v === '' ? 'none' : '';
    }

    sel.addEventListener('change', syncSku);
    syncSku();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
})();